import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = (t: string): any => (supabase as any).from(t)

function todayIso(): string {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

// Count of overdue unpaid bills = accrual expenses that are still owed
// (status pending / partially_paid) and whose bill date has arrived
// (expense_date <= today). `expenses.expected_payment_date` is never populated
// in this app, so the bill's own date is the due date — matching the Accrual
// Schedule tab's `?attention=1` filter so badge and list reconcile.
export function useOverdueBillCount(tid: string, enabled = true) {
  return useQuery<number>({
    queryKey: ['overdue-bill-count', tid],
    enabled: !!tid && enabled,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
    queryFn: async () => {
      const { count } = await db('expenses')
        .select('id', { count: 'exact', head: true })
        .eq('tenant_id', tid)
        .eq('expense_type', 'accrual')
        .in('status', ['pending', 'partially_paid'])
        .lte('expense_date', todayIso())
      return count ?? 0
    },
  })
}
